/**
 * An address.
 *
 * @property {Id}       [addressId]     - The id of address.
 * @property {string}   [color]         - The color of the object.
 * @property {string}   [city]          - The city name of the address
 * @property {string}   [contact]       - The contact information of the address owner.
 * @property {string}   [countryCode]   - The country code of the address.
 * @property {string}   [email]         - The email address of the address owner.
 * @property {string}   [fax]           - The fax number of the address.
 * @property {string}   [federalState]  - The federal state of the address.
 * @property {string}   [info]          - The extra information of the address.
 * @property {number}   [lastModified]  - The last modified timestamp of the address.
 * @property {string}   [location]      - The location of the address.
 * @property {string}   [mapcode]       - The map code of the address..
 * @property {string}   [name1]         - The name of the address, part 1.
 * @property {string}   [name2]         - The name of the address, part 2.
 * @property {string}   [name3]         - The name of the address, part 3.
 * @property {string}   [number]        - The number of the address. Unique within an account.
 * @property {Position} [position]      - The position information of the address, including latitude and longitude.
 * @property {number}   [radius]        - The radius of the address area fence.
 * @property {string}   [street]        - The street name of the address.
 * @property {string}   [telMobile]     - The telephone number of the address.
 * @property {string}   [telOffice]     - The office telephone number of the address
 * @property {string}   [telPrivate]    - The private telephone number of the address.
 * @property {boolean}  [visible]       - The flag to indicate if the address is visible.
 * @property {string}   [zip]           - The zip code of the address.
 */
export class Address {}
